export const defaultColumnWidth = 80;
export const footerHeight = 50;
export const gapBarMaxWidth = 38;
export const gapBarHeight = 30;
export const rowHeight = 50;
export const tableHeight = 350;

export const COLUMN_IDS = {
    CHANNEL: 'channel',
    PROGRAMS: 'programs',
    ADS_AND_PROMOS: 'adsAndPromos',
    AUDIOS: 'audios',
    INCLUDED_AUDIO_FILES: 'includedAudioFiles',
    DETECTIONS: 'detections',
    GAP: 'gap',
    PERFORMANCES: 'performances',
    PAYMENTS: 'payments',
    ESTIMATED_LOSS: 'estimatedLoss',
    INCLUDE_CHANNEL: 'includeChannel',
};

export const columnWidths = {
    [COLUMN_IDS.CHANNEL]: 140,
    [COLUMN_IDS.PROGRAMS]: 72,
    [COLUMN_IDS.ADS_AND_PROMOS]: 68,
    [COLUMN_IDS.AUDIOS]: 50,
    [COLUMN_IDS.DETECTIONS]: 128,
    [COLUMN_IDS.GAP]: 50,
    [COLUMN_IDS.PERFORMANCES]: 128,
    [COLUMN_IDS.PAYMENTS]: 74,
    [COLUMN_IDS.ESTIMATED_LOSS]: 100,
    [COLUMN_IDS.INCLUDE_CHANNEL]: 80,

    // NOTE: total of column widths above must equal 890

    [COLUMN_IDS.INCLUDED_AUDIO_FILES]: 90,
};
